module.exports = __webpack_public_path__ + "img/sample41.85eb6693.jpg";